import { createAction } from '@reduxjs/toolkit';

import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type { BumpMessage, SocketState } from './bumpTypes';

export const setBumpSocketState = createAction('SET_BUMP_SOCKET_STATE', getPayloadCreator<SocketState>());
export const receivedBumpMessage = createAction('RECEIVED_BUMP_MESSAGE', getPayloadCreator<BumpMessage>());
export const sendBumpMessage = createAction('SEND_BUMP_MESSAGE', getPayloadCreator<string | Record<string, unknown>>());
